import styled from 'styled-components';
import { SWEGON_GREEN } from '@swegon-core/uic/dist/src/theme';

type RotatingLoaderProps = {
    $position: 'absolute' | '';
    $size: number;
    $borderSize: number;
};

export const LoaderContainer = styled.div`
    display: inline-flex;
    align-items: center;
`;

export const RotatingLoader = styled.div<RotatingLoaderProps>`
    width: ${(props) => `${props.$size}px`};
    height: ${(props) => `${props.$size}px`};
    margin: auto;
    align-items: center;
    justify-content: center;
    border: ${(props) => `${props.$borderSize}px`} solid ${SWEGON_GREEN};
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;

    position: ${(props) => {
        switch (props.$position) {
            case 'absolute':
                return `
                    absolute;
                    top: 0px;
                    bottom: 0px;
                    left: 0px;
                    right: 0px;
                `;
            default:
                return '';
        }
    }};

    @keyframes rotation {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;
